export default "__VITE_ASSET__Br9$Ip8d__"